<template>
  <div class="the-footer">
    <p>
      {{ $t('app.footer.copyrights') }}
      | <a :href="$t('app.footer.cookies.link')" target="_new">{{ $t('app.footer.cookies') }}</a>
      | <a :href="$t('app.footer.privacy.link')" target="_new">{{ $t('app.footer.privacy') }}</a>
    </p>
  </div>
</template>

<script>
export default {
  name: 'TheFooter',
};
</script>

<style lang="scss">
.the-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;

  height: 40px;
  padding: 0 15px;

  background-color: #000000;

  p {
    font-size: 15px;
    text-transform: uppercase;

    a {
      color: inherit;
      text-decoration: none;

      &:hover {
        color: #ffff00;
      }
    }
  }
}
</style>
